import type { NextPage } from 'next';
import Dashboard from './dashboard';

const Home: NextPage = () => {
    return <Dashboard />;
};

export default Home;
